import { render, staticRenderFns } from "./BillboardCreator.vue?vue&type=template&id=2a0139b4&scoped=true"
import script from "./BillboardCreator.vue?vue&type=script&lang=js"
export * from "./BillboardCreator.vue?vue&type=script&lang=js"
import style0 from "./BillboardCreator.vue?vue&type=style&index=0&id=2a0139b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0139b4",
  null
  
)

export default component.exports